<template>
  <div class="wrapper">
    <div class="col-12">
      {{ title }}
    </div>
    <div class="col-12">
      <slot name="detail">
        <span v-html="detail"/>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ['title', 'detail'],
}
</script>

<style scoped>
.wrapper {
  background-color: #F0F0F0;
  padding: 16px;
  text-align: center;
  color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseNotFoundData.vue